// extracted by mini-css-extract-plugin
export default {"container":"ActionsDropdown_container__7ftCO","trigger":"ActionsDropdown_trigger__2GA71"};